<div class="mt-16 w-full md:px-[3.5rem]">

    @for(auction of auctions; track $index){

    <div
  class="container mx-auto bg-white rounded-lg overflow-hidden border-b
         flex items-center gap-4 lg:gap-8 ">


  <div class="flex-[2] min-w-0">
    <div class="flex items-start">

      <div class="shrink-0 mt-2">
        <a [href]="getAuctionUrl(auction)">
          @if (auction?.auctionHeroImageUrl) {
            <img
              loading="lazy"
              [src]="absoluteMediaUriService.getAbsoluteMediaUri(auction.auctionHeroImageUrl)"
              alt="Org logo"
              class="w-28 h-16 object-fill rounded-lg cursor-pointer"
            />
          } @else {
            <img
              loading="lazy"
              src="auction-no-image.png"
              alt="Org logo"
              class="w-28 h-16 object-fill rounded-lg cursor-pointer"
            />
          }
        </a>
      </div>

    
      <div class="pl-4 flex-1 min-w-0">
        <p class="text-[var(--charcoal)] mt-1">
          {{ auction.orgCause }}
        </p>

        <a [href]="getAuctionUrl(auction)" class="block">
          <p
            class="text-[var(--dark-teal)]
                   font-noto-serif
                   text-xl
                   font-bold
                   cursor-pointer
                   hover:underline
                   line-clamp-3
                   max-w-[85%]"
            [innerHTML]="smartTitleCase(auction.orgName) | sanitizeHtmlText">
          </p>
        </a>
      </div>
    </div>
  </div>


  <div class="flex-none w-24 flex justify-start">
    <fa-icon
      [icon]="auction.isFavorite ? faBookmarkSolid : faBookmarkRegular"
      class="text-3xl text-blue-300 cursor-pointer"
      (click)="toggleFavorite(auction)">
    </fa-icon>
  </div>

  <div class="flex-1 min-w-0">
    <p class="mt-5 text-[var(--fs-dark)] font-semibold">
      {{ dateFormatService.formatDateWithTimezone(
           auction.timezone,
           auction.auctionClosingDate
         ) }}
      <span class="text-sm text-[var(--sky-blue)] font-medium">
        Close date
      </span>
    </p>

    <div class="flex items-end mt-2 gap-6">
      <p class="flex items-center min-w-0">
        <fa-icon
          [icon]="faLocationDot"
          class="text-[var(--sky-blue)]">
        </fa-icon>
        <span class="ml-2 text-[var(--fs-dark)] text-sm">
          {{ smartTitleCase(auction.orgCity) }} {{ auction.orgState }}
        </span>
      </p>

      <p class="text-[var(--charcoal)] font-medium italic text-sm">
        {{
          timeLeftService.getTimeLeft(
            auction.auctionOpeningDate,
            auction.auctionClosingDate
          )
        }}
      </p>
    </div>
  </div>

</div>


    }


</div>